import { IStyle, IToggleStyles } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface ISelectDataSourceStyles {
  root?: IStyle;
  subTitle?: IStyle;
}

export interface ISelectDataSourceClassNames {
  root: string;
  subTitle: string;
}

export const selectDataSourceStylesDefault = (_theme: IH2OTheme): Partial<ISelectDataSourceStyles> => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
    paddingTop: 6,
  },
});

export const toggleStylesSelectDataSource: Partial<IToggleStyles> = {
  root: {
    justifyContent: 'space-between',
    marginRight: '60%',
  },
};
